import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateOverrideRuleStatus } from '../../../api/plan-benefit-override-rules-api'
import { PlanBenefitOverrideRuleStatus } from '../enums/plan-benefit-override-rule.enum'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

interface ToggleVariables {
  id: string
  status: PlanBenefitOverrideRuleStatus
}

export function useToggleOverrideRuleStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, status }: ToggleVariables) =>
      updateOverrideRuleStatus(id, { status }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
